import React from 'react';

import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { CardModal } from 'components/card-modal';
import { LocationEmptyState } from 'components/location-empty-state';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { MenuObjectPage } from 'pages/menu/menu-object-page';
import { MenuProductPage } from 'pages/menu/menu-product-page/menu-product-page';
import { t } from 'state/intl/translations';

export default function MenuObject() {
  const { noStoreSelected } = useStoreRequired();

  if (noStoreSelected) {
    return (
      <CardModal alwaysShowHeader>
        <LocationEmptyState title={t('emptyMenuHeading')} message={t('emptyMenuMessage')} />
      </CardModal>
    );
  }
  return <MenuObjectInner />;
}

const MenuObjectInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();

  return enableUnifiedMenu ? <MenuProductPage /> : <MenuObjectPage />;
});
